import { IPageLoad } from './IPageLoad';
import { UtilityService } from '../../../infrastructure/services/utils';
import { AnalyticsModel } from './AnalyticsModel';
import { AnalyticsActions } from './IAnalyticsTasks';

/**
 * create model for analytics api payload
 * @param   {object} data api payload data
 * @param   {sting} idToken authentication token
 */
export class PageLoadModel extends AnalyticsModel {
  constructor(data: IPageLoad) {
    const paxContextGuid = UtilityService.generateGuid();
    const windowLocation = window.location.href
      ? window.location.href.split('?')[0]
      : window.location.origin + window.location.hash;
    super(data, paxContextGuid);
    if (this.analyticsData.eventData) {
      this.analyticsData.loadPage = [
        {
          ...this.analyticsData.eventData,
          LoadTime: data.LoadTime ? data.LoadTime : 0,
          ActionValue: windowLocation ? windowLocation : null,
          PageURL: windowLocation ? windowLocation : null,
          Action: AnalyticsActions.pageLoad
        }
      ];
      delete this.analyticsData.eventData;
    }
  }
}
